import { FC } from 'react';
import { IconButton } from '../iconButton';
import downloadIcon from 'assets/icons/download-icon.svg';
import downloadWhiteIcon from 'assets/icons/download-icon-white.svg';

interface DownloadIconButtonProps {
	onClick: () => void;
	styles?: {
		iconHeight: string;
		width?: string;
		height?: string;
		margin?: string;
	};
	hide?: boolean;
	light?: boolean;
	id?: string;
}

export const DownloadIconButton: FC<DownloadIconButtonProps> = ({
	onClick,
	styles = { iconHeight: '24px' },
	hide = false,
	light = false,
	id
}) => {
	return (
		<IconButton
			role="download-button"
			iconSrc={light ? downloadWhiteIcon : downloadIcon}
			styles={styles}
			onClick={onClick}
			disableTouch
			hide={hide}
			id={id}
		/>
	);
};
